export default {
  loadingMessage: {
    id: 'checkout_partners_loading_message',
    defaultMessage: 'Nice find on',
  },
  loadingSubMessage: {
    id: 'checkout_partners_loading_sub_message',
    defaultMessage: 'Setting everything up for you on Back Market…',
  },
}
